import { IconSVG } from '../types';

export const ArrowForward = ({ size, style }: IconSVG) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    style={style}
    fill="none"
    viewBox="0 0 25 24"
  >
    <path
      fill="currentColor"
      d="M16.675 13H5.5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4.5 12q0-.424.287-.712A.97.97 0 0 1 5.5 11h11.175l-4.9-4.9a.92.92 0 0 1-.287-.7q.012-.4.312-.7.3-.276.7-.287.4-.013.7.287l6.6 6.6q.15.15.212.325.063.176.063.375 0 .2-.062.375a.9.9 0 0 1-.213.325l-6.6 6.6a.93.93 0 0 1-.687.275q-.413 0-.713-.275-.3-.3-.3-.712 0-.413.3-.713z"
     />
  </svg>
  );
};
